import React from "react";
import { FormInput } from "../../components/inputs/FormInput";
import { Button1st2911 } from "../../components/buttons/Button1st2911";
import Dropdown1st2911 from "../../components/dropdown1st2911";
import { SelectDiv } from "../../Styles/styledComponents/Divs";

const ManageAccount = () => {
  return (
    <>
      <FormInput
        data={{
          name: "name",
          label: "First Name",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "name",
          label: "Last Name",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "number",
          label: "Phone Number",
          width: "100%",
          height: "100px",
        }}
      />
      <FormInput
        data={{
          name: "number",
          label: "Upload Profile Photo",
          width: "100%",
          height: "100px",
        }}
      />

      <SelectDiv>
        <Dropdown1st2911
          data={{
            label: "Select your Alert Sound",
            placeholder: "Select...",
            width: "50%",
          }}
        />
        <Button1st2911 data={{ label: "EDIT" }} />
      </SelectDiv>
    </>
  );
};
export default ManageAccount;
